import type { SVGProps } from 'react';

export function EyeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 3.6c-3.03 0-5.456 1.38-7.223 3.023C3.022 8.253 1.85 10.2 1.29 11.539a1.2 1.2 0 0 0 0 .922c.559 1.34 1.732 3.29 3.487 4.917C6.544 19.016 8.97 20.4 12 20.4s5.456-1.38 7.223-3.022c1.755-1.632 2.928-3.578 3.487-4.917a1.2 1.2 0 0 0 0-.922c-.559-1.339-1.733-3.289-3.488-4.916C17.457 4.983 15.03 3.6 12 3.6M6.6 12c0-2.981 2.419-5.4 5.4-5.4s5.4 2.419 5.4 5.4-2.419 5.4-5.4 5.4A5.4 5.4 0 0 1 6.6 12M12 9.6a2.402 2.402 0 0 1-3.589 2.085 3.602 3.602 0 0 0 4.519 3.791 3.601 3.601 0 0 0-1.245-7.065c.199.35.315.754.315 1.19" />
    </svg>
  );
}
